// core/i18n/languages.constant.ts
export interface Language {
    value: string;
    label: string;
    flagSvg: string;
}

export const LANGUAGES: Language[] = [
    {
        value: 'en',
        label: 'English',
        flagSvg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M23.8984 10.4348H13.5653H13.5652V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4348H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4348V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5652H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348V10.4348Z" fill="#D80027"/>
                    <path d="M15.1304 15.1304L20.4852 20.4852C20.7315 20.239 20.9664 19.9817 21.1906 19.7148L16.6061 15.1304H15.1304V15.1304Z" fill="#D80027"/>
                    <path d="M8.86951 15.1306H8.86941L3.51465 20.4854C3.76084 20.7317 4.01823 20.9666 4.28504 21.1908L8.86951 16.6062V15.1306Z" fill="#D80027"/>
                    <path d="M8.86951 8.8696V8.86951L3.5147 3.51465C3.26842 3.76084 3.03348 4.01823 2.80933 4.28504L7.39384 8.86955H8.86951V8.8696Z" fill="#D80027"/>
                    <path d="M15.1304 8.86956L20.4852 3.51465C20.239 3.26837 19.9817 3.03344 19.7148 2.80933L15.1304 7.39384V8.86956Z" fill="#D80027"/>
                    </svg>`
    },
    {
        value: 'km',
        label: 'Khmer',
        flagSvg: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_721_15320)">
                    <path d="M0 11.9999C0 14.0788 0.528891 16.0342 1.45908 17.739L12 18.7825L22.5409 17.739C23.4711 16.0342 24 14.0788 24 11.9999C24 9.921 23.4711 7.96566 22.5409 6.26077L12 5.21729L1.45908 6.26077C0.528891 7.96566 0 9.921 0 11.9999H0Z" fill="#D80027"/>
                    <path d="M1.45898 6.26086H22.5408C20.5056 2.53073 16.5484 0 11.9999 0C7.45139 0 3.49425 2.53073 1.45898 6.26086V6.26086Z" fill="#0052B4"/>
                    <path d="M11.9999 24.0001C16.5484 24.0001 20.5056 21.4694 22.5408 17.7393H1.45898C3.49425 21.4694 7.45139 24.0001 11.9999 24.0001Z" fill="#0052B4"/>
                    <path d="M16.174 14.3478V12.7826H15.1305V10.6956L14.0871 9.65215L13.0436 10.6956V8.60867L12.0001 7.56519L10.9566 8.60867V10.6956L9.91312 9.65215L8.86964 10.6956V12.7826H7.8262V14.3478H6.78271V15.913H17.2175V14.3478H16.174Z" fill="#F0F0F0"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_721_15320">
                    <rect width="24" height="24" fill="white"/>
                    </clipPath>
                    </defs>
                    </svg>`
    }
];
